module.exports = __webpack_public_path__ + "static/media/Script - Harvest Safety Week 2022_1658234838837.1af46611.docx";